export function withUniqueNames<T extends { name: string }>(items: T[], reserved: readonly string[] = []): T[] {
    const counts = new Map<string, number>(reserved.map((name) => [name, 1]));
    return items.map((item) => {
        const count = (counts.get(item.name) ?? 0) + 1;
        counts.set(item.name, count);
        return count > 1 ? { ...item, name: `${item.name} (${count})` } : item;
    });
}
